import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectStatsCard = ({ icon, label, value, color, bgColor }) => {
  return (
    <div className="bg-white rounded-xl shadow-elevation-2 p-4 md:p-6 transition-smooth hover:shadow-elevation-3">
      <div className="flex items-center gap-3 md:gap-4">
        <div 
          className={`w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center ${bgColor}`}
        >
          <Icon name={icon} size={24} color={color} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-xs md:text-sm text-muted-foreground mb-1">
            {label}
          </div>
          <div className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground">
            {value}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectStatsCard;